import { makeStyles } from '@material-ui/core/styles'

export const useISORepSelectorStyles = makeStyles(theme => ({
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: 12,
      width: 600,
      overflow: 'visible',
      maxHeight: 'none',
    },
    '& .MuiDialog-container': {
      overflow: 'visible',
    },
  },
  dialogHeader: {
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(4),
    borderBottom: `1px solid ${theme.palette.divider}`,
    '& .MuiTypography-h4': {
      margin: 0,
    },
  },
  dialogContent: {
    padding: theme.spacing(3),
    overflow: 'visible',
  },
  closeButton: {
    padding: theme.spacing(0),
    borderRadius: '50%!important',
    border: '1px solid #D0DDE8!important',
    backgroundColor: '#ECF2F8!important',
    width: theme.spacing(2),
    height: theme.spacing(2),
    '&:hover': {
      backgroundColor: '#D0DDE8!important',
    },
    '& svg': {
      '& path': {
        fill: '#738BA5',
      },
    },
  },
  section: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(3),
    gap: theme.spacing(2),
  },
  cancelButton: {
    width: '45%',
  },
  saveButton: {
    width: '45%',
  },
  addButton: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    border: `1px solid #249AF3`,
    '&:hover': {
      backgroundColor: theme.palette.grey[50],
    },
  },
  addButtonSelected: {
    backgroundColor: '#8DC9F8',
    border: `1px solid #249AF3`,
    color: '#ffffff',
    '&:hover': {
      backgroundColor: '#1a7bc7',
    },
  },
  selectedItems: {
    marginTop: theme.spacing(1),
    '& > div:last-child': {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'flex-start',
    },
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  popoverContainer: {
    padding: theme.spacing(3),
    minWidth: 300,
    maxWidth: 350,
  },
  popoverTextField: {
    marginBottom: theme.spacing(3),
  },
}))
